import { createFileRoute } from "@tanstack/react-router"

import { PolicyTunerPage } from "@/admin/policy-tuner/page"
import { loadPolicyTuner } from "@/admin/policy-tuner/policy-tuner-data"
import { getTerminalHeadMeta, TERMINAL_TITLE } from "@/lib/terminal/metadata"

// A fresh list remounts the page, which restarts its replay.
const PolicyTunerRoute = () => {
  const data = Route.useLoaderData()
  return <PolicyTunerPage key={data.generatedAt} data={data} />
}

export const Route = createFileRoute(
  "/_terminalAdmin/terminal/admin/policy-tuner"
)({
  head: () => ({
    meta: getTerminalHeadMeta(`Policy tuner | ${TERMINAL_TITLE}`),
  }),
  loader: () => loadPolicyTuner(),
  // Keep the list until the page is reloaded.
  staleTime: Infinity,
  pendingComponent: () => (
    <p className="text-muted-foreground text-sm">Loading Companies…</p>
  ),
  component: PolicyTunerRoute,
})
